import { useCallback } from 'react';

import { Button } from '@twilio-paste/core/button';
import { useParams } from 'react-router';

import { Can } from '../../components/common/AbilityContext';
import { useDrawer } from '../../components/common/Drawer';
import { PageComponent } from '../../components/common/PageComponent';
import { ScopesTable, ScopesTableContextProvider } from '../../components/Scopes/ScopesTable';
import { Action, Subject } from '../../modules/Permissions';

export function ScopesPage() {
  const { appId = '' } = useParams();
  const createScopeDrawerState = useDrawer();
  const editScopeDrawerState = useDrawer();
  const viewScopeDrawerState = useDrawer();
  const openDrawer = useCallback(() => createScopeDrawerState.show(), [createScopeDrawerState]);

  return (
    <PageComponent
      pageTitle="Scopes"
      actions={
        <Can I={Action.Create} a={Subject.Scope}>
          <Button variant="primary" onClick={openDrawer}>
            New Scope
          </Button>
        </Can>
      }
    >
      <ScopesTableContextProvider
        createScopeDrawerState={createScopeDrawerState}
        editScopeDrawerState={editScopeDrawerState}
        viewScopeDrawerState={viewScopeDrawerState}
      >
        <ScopesTable appId={appId} />
      </ScopesTableContextProvider>
    </PageComponent>
  );
}
